<template>
  <div id="devis" class="page">
    <section class="page-image page-title">
      <div class="container">
        <div class="row">
          <div class="col-xs-12" @click.prevent="openModal('modal-3d')">
            <h1>Oxynov-3D, <br>devis garde-corps</h1>
          </div>
        </div>
      </div>
    </section>
    <section class="page-title">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <ol class="breadcrumb">
              <li>
                <router-link to="/">Accueil</router-link>
              </li>
              <li>Devis 3D</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
    <section class="faq-pg-section section-padding-50">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <h2>Essayez notre calculateur <div>de garde-corps sur mesure</div></h2>
          </div>
          <div class="col-xs-12 col-md-6">
            <button class="btn btn-primary btn-outlined" @click.prevent="openModal('modal-3d')">Lancer le devis 3D</button>
          </div>
        </div>
      </div>
    </section>
    <section class="faq-pg-section section-padding-50" style="padding-top: 0;">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <blockquote>Notre outil <strong>« Oxynov-3D »</strong>, vous permet de dessiner vous-même, gratuitement, votre projet en quelques clics.</blockquote>
          </div>
          <div class="col-md-4">
            <blockquote>Le dessin de votre <strong>garde-corps</strong> s'affiche en <strong>3D</strong>.</blockquote>
          </div>
          <div class="col-md-4">
            <blockquote>Téléchargez ensuite votre <strong>devis détaillé en PDF</strong> avec une <strong>notice d'installation</strong> complète comprenant une vue 3D, 2D et conseils de pose.</blockquote>
          </div>
        </div>
        <div class="row">
          <div id="vertical-slider">
            <div class="col-md-4 no-pad-r">
              <div class="list-group">
                <a v-for="(v, k) in steps" v-bind:key="k" href="#" :rel="k" class="list-group-item" :class="{ active: activeSlide === k }" @click.prevent="goToSlide(k)">
                  <i>{{ k + 1 }}</i>
                  <span>{{ v }}</span>
                </a>
              </div>
            </div>
            <div class="col-md-8 pad-l-2">
              <swiper :options="swiperOption" ref="mySwiper" @slideChange="slideChange()">
                <swiper-slide v-for="(v, k) in steps" v-bind:key="k" :style="{ backgroundImage: 'url(/static/images/devis/steps/aide-devis-oxynov0' + (k + 1) + '.jpg)' }"></swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { EventBus } from '@/event-bus.js'

export default {
  name: 'Devis',
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  data () {
    return {
      activeSlide: 0,
      steps: [
        'Générez un devis de garde-corps',
        'Créez un projet de garde-corps',
        'Définissez les caractéristiques du garde-corps',
        'Laissez-vous guider',
        'Ajoutez vos élements segment par segment',
        'Ajoutez un escalier ou un angle',
        'Sélectionnez le type de fixation',
        'Sauvegardez vos devis',
        'Téléchargez le devis et les plans 2D et 3D'
      ],
      swiperOption: {
        direction: 'vertical',
        effect: 'fade',
        allowTouchMove: false,
        autoplay: {
          delay: 5000
        }
      }
    }
  },
  methods: {
    goToSlide (index) {
      this.swiper.slideTo(index, 1000, false)
    },
    slideChange (slide) {
      this.activeSlide = this.swiper.realIndex
    },
    openModal (name) {
      EventBus.$emit('open-modal', 'modal-3d')
    }
  }
}
</script>

<style scoped>
.page-title h1 {
  margin: 0em 0 2.23em;
}
.page-title h2 {
  font-size: 14px;
  color: #025d90;
  font-weight: 100;
  margin: 1em 0 1em;
}
.page-image {
  background: url(/static/images/devis/devis-garde-corps-3D.jpg) center center/cover no-repeat local;
  height: 260px;
  position: relative;
  width: 100%;
}
.blockquote {
  font-size: 14px;
}
.list-group {
  margin-bottom: 0;
}
.list-group-item {
  padding: 15px 10px 15px 61px;
  border: 0;
  background-color: #f7f7f7;
  border-radius: 0;
  margin-bottom: 2px;
  position: relative;
}
.list-group-item i {
  position: absolute;
  width: 51px;
  height: 100%;
  background-color: #025d90;
  color: #fff;
  left: 0;
  top: 0;
  line-height: 51px;
  text-align: center;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
}
.no-pad-r {
  padding-right: 0;
}
.no-pad-l {
  padding-left: 0;
}
#vertical-slider {
  height: 475px;
}
#vertical-slider > .col-md-8,
#vertical-slider .swiper-container {
  height: 100%;
}
#vertical-slider .swiper-slide {
  background-size: contain;
}
#vertical-slider .pad-l-2 {
  padding-left: 2px;
}
.list-group-item.active {
  background-color: #025d90;
}
.list-group-item.active:after {
  content: '';
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 25.5px 0 25.5px 20px;
  border-color: transparent transparent transparent #025c90;
  position: absolute;
  right: -20px;
  top: 0px;
}
.faq-pg-section h2 {
  font-size: 30px;
  font-size: 2rem;
  line-height: 1.33em;
  padding-bottom: 0.3em;
  position: relative;
  margin: 0 0 0.83em;
}
.faq-pg-section h2:before {
  content: "";
  background-color: #005e90;
  width: 80px;
  height: 2px;
  position: absolute;
  left: 0;
  bottom: 0;
}
.faq-pg-section h2 div {
  font-size: 1.5rem;
  color: #698490;
}
.btn-primary.btn-outlined {
  font-size: 22px;
  background-color: #013d5d;
  border-color: #013d5d;
  color: #fff;
  float: left;
  margin: 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Devis.vue